export const languageTypes = {
  en: "en",
  fr: "fr",
};
